import axios, { AxiosResponse } from 'axios'
import { URL_BACKOFFICE } from '@/configs'
import { getAuthHeader } from '@/firebase/config'

const { get, post, put } = axios

const onError = (err: any) => {
  // tslint:disable-next-line:no-console
  console.error(err)
  return false
}

export const findCompany: (
  tenantName: string
) => Promise<any | undefined> = async (tenantName: string) => {
  try {
    const {
      data: { company, participation },
    } = (await get(
      `${URL_BACKOFFICE}/accounts/companies?tenant=${tenantName}`,
      await getAuthHeader()
    )) as AxiosResponse<any>

    const {
      deliverySurveyDate,
      billing: { expiresAt },
    } = company

    company.deliverySurveyDateObj = deliverySurveyDate
      ? new Date(Date.parse(deliverySurveyDate))
      : undefined

    company.billing.expiresAtObj = expiresAt
      ? new Date(Date.parse(expiresAt))
      : undefined

    company.billing.availableLicenses = Number(
      company.billing.availableLicenses
    )

    return { company, participation }
  } catch (error) {
    onError(error)
  }
}

export const resendCompanyInvites = async (tenantName: string) =>
  post(
    `${URL_BACKOFFICE}/email/confirmation?send=true`,
    {
      tenant: tenantName,
      allUsers: true,
    },
    await getAuthHeader()
  ).catch(onError)

export const updateCompany = async (
  tenantName: string,
  {
    modules,
    deactivated,
    billing: { plan, availableLicenses, expiresAt },
    layoutRules,
  }: any
) =>
  put(
    `${URL_BACKOFFICE}/accounts/companies/${tenantName}`,
    {
      modules,
      deactivated,
      billing: { plan, availableLicenses, expiresAt },
      layoutRules,
    },
    await getAuthHeader()
  ).catch(onError)

export default {
  findCompany,
  resendCompanyInvites,
}
